import { ButtonProps } from 'lib/components/Button/Button'
import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

import { IconListItem } from '@/components/IconList'

import { AffiliatePageContent } from './shipsticks.page.content'

const BACKGROUND_IMAGE = '/images/shipskis/affiliate-hero.jpg'

const hero: NarrativeHeroProps = {
  backgroundImage: BACKGROUND_IMAGE,
  header: 'Join our affiliate program.',
  subHeader: `
    Earn money and make ski travel easy for your
    followers with the most trusted name in winter gear shipping.
  `,
  button: {
    children: 'Become an affiliate',
    link: {
      href: '#lead-form',
    },
    variant: 'secondary',
  },
}

const fifties: FiftyFiftyProps[] = [
  {
    image: {
      src: '/images/shipskis/affiliate-1.jpg',
    },
    backgroundColor: 'white',
    header: 'Why us?',
    layout: 'image-right',
    button: {
      text: 'Become an Affiliate',
      link: {
        href: '#lead-form',
      },
    },
    body: (
      <>
        ShipSkis makes winter travel a breeze by shipping skis, boards, boots and luggage right to
        the resort or rental and back again. With thousands of 5-star reviews, ShipSkis is a service
        you can recommend with confidence.
      </>
    ),
    showEyebrow: false,
  },
  {
    image: {
      src: '/images/shipskis/affiliate-2.jpg',
    },
    backgroundColor: 'white',
    header: 'What’s in it for you?',
    layout: 'image-left',
    body: (
      <>
        In exchange for sharing the benefits of using ShipSkis, you&apos;ll receive financial
        rewards as well as genuine appreciation from followers who use the service.
      </>
    ),
    showEyebrow: false,
  },
  {
    image: {
      src: '/images/shipskis/affiliate-3.jpg',
    },
    backgroundColor: 'white',
    header: 'How to join.',
    layout: 'image-right',
    button: {
      text: 'Become an Affiliate',
      link: {
        href: '#lead-form',
      },
    },
    body: (
      <>
        Joining is FREE. Just fill out the form linked below, and we&apos;ll help you find the
        partnership that makes the most sense (and money) for you.
      </>
    ),
    showEyebrow: false,
  },
]

const iconListHeader: string = 'Things to brag about'

const iconList: IconListItem[] = [
  {
    icon: 'check-circle-filled',
    header: 'Trusted by skiers worldwide',
    body: (
      <>
        With more than 500,000 bags shipped annually, ShipSkis is the most trusted name in winter
        travel.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Premium experience',
    body: (
      <>
        Real-time tracking, free insurance, and customer support 7 days a week makes for a much
        better experience than trusting your gear with the airlines.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'In good company',
    body: (
      <>
        We partner with more than 3,500 destinations around the world. They trust us to deliver
        exceptional service and so can your followers.
      </>
    ),
  },
]

const leadFormProps = {
  header: 'Let’s talk.',
  subHead: (
    <>
      Becoming a ShipSkis affiliate is simple, fast, and free. Want in? Fill out the form to get
      started - we’ll be in touch with next steps.
    </>
  ),
}

const ctaHeader: string =
  'Are you representing a hotel, resort or travel service? Are you a mountain operator?'
const ctaBody: string = 'If so, check out our partner page.'
const ctaButtonLink: ButtonProps = {
  link: {
    href: '/partnership-benefits',
    target: '_self',
  },
  variant: 'secondary',
}
const ctaButtonText: string = 'Learn More'

const content: AffiliatePageContent = {
  hero,
  fifties,
  iconListHeader,
  iconList,
  leadFormProps,
  ctaHeader,
  ctaBody,
  ctaButtonLink,
  ctaButtonText,
}

export default content
